import {Rule} from 'Event/attendee-rules'
import styled from 'styled-components'
import React from 'react'
import {useState} from 'react'
import RuleList from 'Event/attendee-rules/RuleConfig/RuleList'
import {Form} from 'organization/Event/FormsProvider'

export type RuleConfigProps = {
  children?: React.ReactElement
  visible: boolean
  close?: () => void
  onChange: (rules: Rule[]) => void
  rules?: Rule[]
  description?: string
  className?: string
  title?: string
  disabled?: boolean
  additionalRules?: JSX.Element
  form?: Form
}

export default function RuleConfig(props: RuleConfigProps) {
  if (!props.visible) {
    return props.children || null
  }

  return (
    <Box className={props.className}>
      <StyledRuleList
        disabled={props.disabled}
        rules={props.rules}
        close={props.close}
        onChange={props.onChange}
        description={props.description}
        paddingBottom={Boolean(props.additionalRules)}
        form={props.form}
      />
      {props.additionalRules}
    </Box>
  )
}

export function useRuleConfig() {
  const [visible, setVisible] = useState(false)

  const toggle = () => setVisible(!visible)

  const close = () => setVisible(false)

  return {
    visible,
    toggle,
    close,
  }
}

const StyledRuleList = styled(RuleList)<{
  paddingBottom?: boolean
}>`
  margin-bottom: ${(props) =>
    props.paddingBottom ? props.theme.spacing[4] : 0};
`

const Box = styled.div`
  margin-bottom: ${(props) => props.theme.spacing[5]};
`
